import { HttpClient } from '@remodeling/base';
import {
  GetConstructCaseCheckCounselor,
  GetConstructionCaseListGateway,
} from '@remodeling/content';
import { axios } from '../../axios';

export const constructionCaseGateway = () => {
  return {
    getList: new GetConstructionCaseListGateway(axios),
    // 전문가 컨텐츠 여부
    getCheckCounselor: new ClientGetConstructCaseCheckCounselor(axios),
  };
};

class ClientGetConstructCaseCheckCounselor {
  constructor(readonly httpClient: HttpClient) {}

  async exec() {
    const apiResponse = await new GetConstructCaseCheckCounselor(
      this.httpClient,
    ).exec();

    if (apiResponse.code === 200) {
      return apiResponse.data?.counselorYn.toLocaleLowerCase() === 'true';
    }

    return false;
  }
}
